import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ContextMenu, renderContextMenuItems } from "@air/primitive-context-menu";
import classNames from "classnames";
import { memo, useCallback, useState } from "react";
import { flushSync } from "react-dom";
import { GalleryCardSelectionButton } from "~/components/Gallery/GalleryCard/GalleryCardSelectionButton";
import { useSelectableCard } from "~/hooks/useSelectableCard";
import { useSelectionAwareContextMenuOptions } from "~/hooks/useSelectionAwareContextMenuOptions";
function _GalleryCard(param) {
    let { item, testId, title, getItemMenuOptions, getSelectionMenuOptions, isSelectable = true, onClick, onMouseLeave, onMouseMove, children, getButtonClassName } = param;
    const { onBlur, onFocus, handleHover, isHovering, handleItemClick, handleItemDoubleClick, handleUnhover, confirmItemSelection, preSelectItem, itemRef, isSelected, isHighlighted } = useSelectableCard({
        item,
        onClick,
        isSelectable
    });
    /** Sub Menu */ const [isMenuOpen, setIsMenuOpen] = useState(false);
    const contextMenuOptions = getItemMenuOptions({
        trackLocation: "gallery-item-context-menu"
    });
    /** Context Menu */ const { options } = useSelectionAwareContextMenuOptions({
        contextMenuOptions,
        id: item.id,
        selectionMenuOptions: getSelectionMenuOptions("gallery-multi-select-context-menu")
    });
    const handleMouseEnter = useCallback(()=>{
        flushSync(()=>{
            handleHover();
        });
    }, [
        handleHover
    ]);
    const handleMouseMove = useCallback((event)=>{
        handleMouseEnter();
        onMouseMove === null || onMouseMove === void 0 ? void 0 : onMouseMove(event);
    }, [
        handleMouseEnter,
        onMouseMove
    ]);
    const handleMouseLeave = useCallback((event)=>{
        handleUnhover();
        onMouseLeave === null || onMouseLeave === void 0 ? void 0 : onMouseLeave(event);
    }, [
        handleUnhover,
        onMouseLeave
    ]);
    /**
   * If the menu is open, we want to keep the hover state active
   */ const _isHovering = isHovering || isMenuOpen;
    return /*#__PURE__*/ _jsx(ContextMenu, {
        trigger: /*#__PURE__*/ _jsxs("div", {
            "data-testid": testId,
            "data-asset-title": title,
            "data-test-isselected": isSelected,
            className: classNames("flex h-full flex-col"),
            onBlur: onBlur,
            onFocus: onFocus,
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            onMouseMove: handleMouseMove,
            ref: itemRef,
            children: [
                /*#__PURE__*/ _jsx(GalleryCardSelectionButton, {
                    confirmItemSelection: confirmItemSelection,
                    isSelectable: isSelectable,
                    onClick: onClick,
                    onDoubleClick: handleItemDoubleClick,
                    preSelectItem: preSelectItem,
                    isHovering: _isHovering,
                    isHighlighted: isHighlighted || isSelected,
                    className: getButtonClassName === null || getButtonClassName === void 0 ? void 0 : getButtonClassName({
                        isSelected
                    })
                }),
                children({
                    setIsMenuOpen,
                    isMenuOpen,
                    onBlur,
                    onFocus,
                    handleHover,
                    isHovering: _isHovering,
                    handleItemClick,
                    handleItemDoubleClick,
                    handleUnhover,
                    confirmItemSelection,
                    preSelectItem,
                    itemRef: itemRef,
                    isSelected,
                    isHighlighted
                })
            ]
        }),
        children: renderContextMenuItems({
            options
        })
    });
}
export const GalleryCard = /*#__PURE__*/ memo(_GalleryCard);
